import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseDataService } from './base.data.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IJobHoldSettings } from '../interfaces/job-hold/job-hold-settings';

@Injectable({
  providedIn: 'root',
})
export class JobHoldService extends BaseDataService {
  public url = '/api/job-hold';

  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getSettings() {
    return this.http.get<IJobHoldSettings>(this.url + '/settings').toPromise();
  }

  public saveSettings(settings: IJobHoldSettings) {
    return this.http.post<IJobHoldSettings>(this.url + '/settings', settings).toPromise();
  }
}
